import RatingStars from '../../utils/RatingStars';
import { useRefresh } from '../../utils/RefreshProvider';
import { useTranslation } from 'react-i18next';
import WriteReview from './WriteReview';
import { StarIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import axios from 'axios';
import RemoveComment from './components/RemoveComment';

export default function ReviewsPart({ productId, ratingProp }) {
  const { t } = useTranslation();
  const { refreshKey } = useRefresh();
  const token = localStorage.getItem('token');
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [reviews, setReviews] = useState([]);
  const [statsReviews, setStatsReviews] = useState([]);
  const [userId, setUserId] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [btnShowAll, setBtnShowAll] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${localhost}user`, { headers: { 'Authorization': `Bearer ${token}` } });
        setUserId(res.data.id);
      } catch (err) {
        // 
      }
    }

    const fetchReviews = async () => {
      try {    
        const res = await axios.get(`${localhost}review/${productId}`);
        const all = showAll ? res.data : res.data.slice(0, 4);
        setBtnShowAll(res.data.length > 4);
        setReviews(all);
      } catch (err) {
        // 
      }
    };

    const fetchStatsReviews = async () => {
      try {
        const res = await axios.get(`${localhost}stats-reviews/${productId}`);
        setStatsReviews(res.data);
      } catch (err) {
        // 
      }
    };

    fetchUser();
    fetchReviews();
    fetchStatsReviews();
  }, [showAll, refreshKey]);

  return (
    <div className='my-24'>
      <p className="text-xl font-semibold text-black mb-6">{t("recent-reviews")}</p>
      <div className="grid grid-cols-1 md:grid-cols-6 gap-8 md:gap-0">
        {/* Left Column - Overall Rating */}
        <div className='md:col-span-2 md:border-r md:pr-10 md:mr-10'>
          <div className="flex items-center gap-2 mb-4">
            <RatingStars rating={ratingProp} size='20px' />
            <span className="text-gray-600 ml-2 text-sm font-normal leading-none">{reviews.length} {t("reviews")}</span>
          </div>

          {/* Rating Bars */}
          <div className="space-y-3">
            {statsReviews.map((item, index) => (
              <div key={index} className="flex items-center gap-2">
                <span className="w-4">{item.id}</span>
                <StarIcon className="w-4 h-4 text-yellow-400" />
                <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                  <div className="h-full bg-yellow-400" style={{ width: `${item.percentage}%` }} />
                </div>
                <span className="w-12 text-sm text-gray-600">{item.percentage}%</span>
              </div>
            ))}
          </div>

          {/* Review Form */}
          <div className="mt-8">
            <h3 className="font-semibold mb-1">{t("review-text.item1")}</h3>
            <p className="text-sm text-gray-600 mb-4">
              {t("review-text.item2")}
            </p>
            <WriteReview product_id={productId} />
          </div>
        </div>

        {/* Right Column - Individual Reviews */}
        <div className="space-y-10 md:col-span-4">
          {reviews.map((item, index) => (
            <div key={index} className={`${index > 0 ? "border-t pt-10" : ""}`}>
              <div className="flex gap-x-8">
                <div className="flex-none w-32">
                  <p className="text-sm font-semibold text-black capitalize">{item.username}</p>
                  <div className="mt-2">
                    <RatingStars rating={item.rating} size='16px' color='black' />
                  </div>
                </div>
                <div className="flex-grow min-w-0">
                  <div className="flex justify-between items-start gap-x-4">
                    <p className="text-sm text-gray-600 break-words">{item.comment}</p>
                    {
                      item.user_id === userId ? <RemoveComment review_id={item.id} /> : null
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="flex justify-end">
            {btnShowAll ? <button onClick={() => setShowAll(!showAll)} className="my-3 border rounded-md px-4 py-2 text-sm text-gray-900 hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500">
              {showAll ? t("see-less") : t("see-more")}
            </button> : null}
          </div>
        </div>

      </div>
    </div>
  )
}
